<template>
  <div class="page-container">
    <div class="query-title">期初历史制票通知单批导</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template slot="button">
            <el-popover placement="bottom" trigger="click">
              <el-button size="mini" @click="handleImportExcel('V001')">配额酒制票单批导</el-button>
              <el-button size="mini" @click="handleImportExcel('V002')">非配额酒制票单批导</el-button>
              <table-button slot="reference" name="import" tip="历史制票单批导" />
            </el-popover>

            <table-button
              name="download"
              tip="非配额酒制票单模板下载"
              @click="downloadTemplate('invoiceNoQuota.xlsx','五粮液非配额酒批条酒制票通知单批导模板_20181008_V1.0.xlsx')"
            />
            <table-button
              name="download"
              tip="配额酒制票单模板下载"
              @click="downloadTemplate('invoiceQuota.xlsx', '五粮液配额酒制票通知单批导模板_20181008_V1.0.xlsx')"
            />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #batch_number="{ row }">
              <span class="blue" @click="toDetail(row)">{{ row.batch_number }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import {
  apiInvoiceImportList,
  apiInvoiceImport,
  apiSapInvoiceImport
} from '@/api/sap/make-invoice-sap'
import tableMixins from '@/utils/tableMixins'
import pageConfig from '../config/BatchQuery'
import { downloadLocalFile } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [{ type: 'checkbox', title: '', field: 'checkbox', width: 50 }],
        data: []
      },
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    // 模板下崽
    async downloadTemplate(file = 'invoiceQuota.xlsx', filename) {
      downloadLocalFile(file, filename)
    },
    // 导入excel
    async handleImportExcel(type) {
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async({ file }) => {
          this.batch_type = type
          const formData = new FormData()
          formData.append('file', file)

          const { data } = await apiInvoiceImport(formData)
          if (data.hd.length && data.itm.length) {
            this.uploadFile(file, data)
          } else {
            this.$message.error('上传文件中数据为空！')
          }
        })
    },
    async uploadFile(file, data) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')

        const params = {
          batch_type: _this.batch_type,
          filename: file.name,
          mimetype: file.type,
          filedata: strArr,
          head: data.hd,
          user_bp: this.$store.getters.role.USER_BP,
          [_this.batch_type === 'V001' ? 'item1' : 'item2']: data.itm
        }
        apiSapInvoiceImport(params).then(res => {
          if (res.MSGTYPE === 'E') {
            return _this.$message.error(res.MESSAGE)
          }
          _this.$emit('change-action', 'batch', res.DATA)
        })
      }
    },
    toDetail(row) {
      this.$emit('change-action', 'batch', row.batch_number)
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        partner: this.$store.getters.role.USER_BP,
        roles: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiInvoiceImportList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/invoice-manage/components/BatchQuery.vue